// Known mail-provider presets → auto-fill SMTP/IMAP host & ports from an email
// address so users never look up server settings. Frontend-only helper.
export const MAIL_PROVIDERS = {
  gmail: {
    name: 'Gmail / Google Workspace',
    domains: ['gmail.com', 'googlemail.com'],
    smtp_host: 'smtp.gmail.com', smtp_port: 465,
    imap_host: 'imap.gmail.com', imap_port: 993,
    note: 'Use an App Password (myaccount.google.com/apppasswords), not your normal password.',
  },
  outlook: {
    name: 'Outlook / Microsoft 365',
    domains: ['outlook.com', 'hotmail.com', 'live.com', 'office365.com', 'msn.com'],
    smtp_host: 'smtp.office365.com', smtp_port: 587,
    imap_host: 'outlook.office365.com', imap_port: 993,
    note: 'You may need to enable IMAP/SMTP AUTH in your Microsoft admin settings.',
  },
  zoho: {
    name: 'Zoho Mail',
    domains: ['zoho.com', 'zohomail.com'],
    smtp_host: 'smtp.zoho.com', smtp_port: 465,
    imap_host: 'imap.zoho.com', imap_port: 993,
    note: 'Use an app-specific password from Zoho → Security → App Passwords.',
  },
  zoho_in: {
    name: 'Zoho Mail (India)',
    domains: ['zoho.in'],
    smtp_host: 'smtp.zoho.in', smtp_port: 465,
    imap_host: 'imap.zoho.in', imap_port: 993,
    note: 'India (.in) data center — use an app-specific password from Zoho → Security → App Passwords.',
  },
  yahoo: {
    name: 'Yahoo Mail',
    domains: ['yahoo.com', 'ymail.com', 'rocketmail.com'],
    smtp_host: 'smtp.mail.yahoo.com', smtp_port: 465,
    imap_host: 'imap.mail.yahoo.com', imap_port: 993,
    note: 'Generate an app password in your Yahoo account security settings.',
  },
  icloud: {
    name: 'iCloud Mail',
    domains: ['icloud.com', 'me.com', 'mac.com'],
    smtp_host: 'smtp.mail.me.com', smtp_port: 587,
    imap_host: 'imap.mail.me.com', imap_port: 993,
    note: 'Create an app-specific password at appleid.apple.com.',
  },
};

// Returns {key, name, smtp_host, smtp_port, imap_host, imap_port, note?, custom?}
export function detectProvider(email) {
  const domain = (String(email || '').split('@')[1] || '').toLowerCase().trim();
  if (!domain) return null;
  for (const [key, p] of Object.entries(MAIL_PROVIDERS)) {
    if (p.domains.includes(domain)) return { key, ...p };
  }
  // Custom domain: best-effort common convention (user can edit in Advanced).
  return {
    key: 'custom',
    name: `Custom domain (${domain})`,
    smtp_host: `mail.${domain}`, smtp_port: 465,
    imap_host: `imap.${domain}`, imap_port: 993,
    note: 'We guessed your server settings from your domain — edit them if your host differs.',
    custom: true,
  };
}
